import { defineMessages } from '../define';

/** Strings shared by many screens: navigation, global states, money words, statuses. */
export const commonMessages = defineMessages(
  {
    appName: 'Split',
    skipToContent: 'Skip to content',
    navMain: 'Main',
    navHome: 'Home',
    navGroups: 'Groups',
    navActivity: 'Activity',
    navMe: 'Me',
    navNotifications: 'Notifications',
    navAdmin: 'Admin',
    addExpense: 'Add expense',
    bellLabel:
      '{count, plural, =0 {Notifications} one {Notifications, # unread} other {Notifications, # unread}}',
    profileAndSettings: 'Profile and settings',
    back: 'Back',
    close: 'Close',
    cancel: 'Cancel',
    done: 'Done',
    save: 'Save',
    saved: 'Saved',
    continue: 'Continue',
    edit: 'Edit',
    remove: 'Remove',
    delete: 'Delete',
    undo: 'Undo',
    retry: 'Retry',
    tryAgain: 'Try again',
    copy: 'Copy',
    copied: 'Copied',
    share: 'Share',
    qr: 'QR',
    more: 'More',
    seeAll: 'See all',
    search: 'Search',
    clearSearch: 'Clear search',
    loading: 'Loading',
    you: 'You',
    youLower: 'you',
    youSuffix: '{name} (you)',
    offlineBanner: "You're offline. Changes are saved on this device and will sync later.",
    offlineAction: 'Connect to the internet to do this.',
    synced: 'Synced',
    waitingToSync: 'Waiting to sync',
    syncFailed: "Couldn't sync. Retry",
    lastUpdated: 'Last updated {time}',
    genericError: 'Something went wrong. Try again.',
    couldNotSave: "Couldn't save. Try again.",
    amountTooLarge: 'That amount is too large.',
    amountTooManyDecimals:
      '{max, plural, =0 {{currency} amounts have no decimals.} one {{currency} amounts have at most # decimal.} other {{currency} amounts have at most # decimals.}}',
    rateLimited: 'Too many attempts. Try again in a few minutes.',
    notFoundTitle: 'Page not found',
    notFoundBody: "The page you're looking for doesn't exist.",
    goneTitle: "That's no longer available",
    goneBody: 'It may have been deleted, or you left the group.',
    goHome: 'Go home',
    updateAvailable: 'A new version of Split is ready.',
    reload: 'Reload',
    offlineReady: 'Split now works offline.',
    // Money words
    youOwe: 'You owe',
    youAreOwed: 'You are owed',
    youOweLower: 'you owe',
    youAreOwedLower: 'you are owed',
    owesYou: 'Owes you',
    settledUp: 'Settled up',
    isOwed: 'Is owed',
    owes: 'Owes',
    owe: 'Owe',
    // Spoken amounts (screen readers, DESIGN 7)
    srOwed: 'You are owed {amount}',
    srOwe: 'You owe {amount}',
    srSettled: 'Settled up',
    srAbout: 'About {amount}',
    srMemberOwed: '{name} is owed {amount}',
    srMemberOwes: '{name} owes {amount}',
    // Dates
    today: 'Today',
    yesterday: 'Yesterday',
    // Statuses
    statusUnused: 'Unused',
    statusUsed: 'Used',
    statusExpired: 'Expired',
    statusRevoked: 'Revoked',
    statusPending: 'Pending',
    statusConfirmed: 'Confirmed',
    statusDisputed: 'Disputed',
    statusCancelled: 'Cancelled',
    notJoined: 'Not joined',
    notJoinedLower: 'not joined',
    admin: 'Admin',
    member: 'Member',
    disabled: 'Disabled',
    muted: 'Muted',
    unread: 'Unread',
    people: '{count, plural, one {# person} other {# people}}',
    // Sheets
    currency: 'Currency',
    currencyLabel: 'Currency: {name}. Change',
    searchCurrencies: 'Search currencies',
    recent: 'Recent',
    inThisGroup: 'In this group',
    allCurrencies: 'All currencies',
    noResults: 'No results',
    pickEmoji: 'Pick an emoji',
    searchEmoji: 'Search emoji',
    scanQr: 'Scan QR',
    scanQrHint: 'Point the camera at a QR code.',
    cameraUnavailable: "Couldn't open the camera. Paste the code instead.",
    qrCaption: 'Scan with a phone camera',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    confirm: 'Confirm',
  },
  {
    appName: 'Split',
    skipToContent: 'Saltar al contenido',
    navMain: 'Principal',
    navHome: 'Inicio',
    navGroups: 'Grupos',
    navActivity: 'Actividad',
    navMe: 'Yo',
    navNotifications: 'Notificaciones',
    navAdmin: 'Administración',
    addExpense: 'Añadir gasto',
    bellLabel:
      '{count, plural, =0 {Notificaciones} one {Notificaciones, # sin leer} other {Notificaciones, # sin leer}}',
    profileAndSettings: 'Perfil y ajustes',
    back: 'Atrás',
    close: 'Cerrar',
    cancel: 'Cancelar',
    done: 'Hecho',
    save: 'Guardar',
    saved: 'Guardado',
    continue: 'Continuar',
    edit: 'Editar',
    remove: 'Quitar',
    delete: 'Eliminar',
    undo: 'Deshacer',
    retry: 'Reintentar',
    tryAgain: 'Inténtalo de nuevo',
    copy: 'Copiar',
    copied: 'Copiado',
    share: 'Compartir',
    qr: 'QR',
    more: 'Más',
    seeAll: 'Ver todo',
    search: 'Buscar',
    clearSearch: 'Borrar búsqueda',
    loading: 'Cargando',
    you: 'Tú',
    youLower: 'tú',
    youSuffix: '{name} (tú)',
    offlineBanner:
      'Sin conexión. Los cambios se guardan en este dispositivo y se sincronizarán después.',
    offlineAction: 'Conéctate a internet para hacer esto.',
    synced: 'Sincronizado',
    waitingToSync: 'Pendiente de sincronizar',
    syncFailed: 'No se pudo sincronizar. Reintentar',
    lastUpdated: 'Actualizado a las {time}',
    genericError: 'Algo ha fallado. Inténtalo de nuevo.',
    couldNotSave: 'No se pudo guardar. Inténtalo de nuevo.',
    amountTooLarge: 'Ese importe es demasiado grande.',
    amountTooManyDecimals:
      '{max, plural, =0 {Los importes en {currency} no llevan decimales.} one {Los importes en {currency} llevan como mucho # decimal.} other {Los importes en {currency} llevan como mucho # decimales.}}',
    rateLimited: 'Demasiados intentos. Inténtalo de nuevo en unos minutos.',
    notFoundTitle: 'Página no encontrada',
    notFoundBody: 'La página que buscas no existe.',
    goneTitle: 'Ya no está disponible',
    goneBody: 'Puede que se haya eliminado o que hayas salido del grupo.',
    goHome: 'Ir al inicio',
    updateAvailable: 'Hay una versión nueva de Split.',
    reload: 'Recargar',
    offlineReady: 'Split ya funciona sin conexión.',
    youOwe: 'Debes',
    youAreOwed: 'Te deben',
    youOweLower: 'debes',
    youAreOwedLower: 'te deben',
    owesYou: 'Te debe',
    settledUp: 'Todo saldado',
    isOwed: 'Le deben',
    owes: 'Debe',
    owe: 'Debes',
    srOwed: 'Te deben {amount}',
    srOwe: 'Debes {amount}',
    srSettled: 'Al día',
    srAbout: 'Unos {amount}',
    srMemberOwed: 'A {name} le deben {amount}',
    srMemberOwes: '{name} debe {amount}',
    today: 'Hoy',
    yesterday: 'Ayer',
    statusUnused: 'Sin usar',
    statusUsed: 'Usada',
    statusExpired: 'Caducada',
    statusRevoked: 'Revocada',
    statusPending: 'Pendiente',
    statusConfirmed: 'Confirmado',
    statusDisputed: 'En disputa',
    statusCancelled: 'Cancelado',
    notJoined: 'Sin unirse',
    notJoinedLower: 'sin unirse',
    admin: 'Admin',
    member: 'Miembro',
    disabled: 'Desactivada',
    muted: 'Silenciado',
    unread: 'Sin leer',
    people: '{count, plural, one {# persona} other {# personas}}',
    currency: 'Moneda',
    currencyLabel: 'Moneda: {name}. Cambiar',
    searchCurrencies: 'Buscar monedas',
    recent: 'Recientes',
    inThisGroup: 'En este grupo',
    allCurrencies: 'Todas las monedas',
    noResults: 'Sin resultados',
    pickEmoji: 'Elegir emoji',
    searchEmoji: 'Buscar emoji',
    scanQr: 'Escanear QR',
    scanQrHint: 'Apunta la cámara a un código QR.',
    cameraUnavailable: 'No se pudo abrir la cámara. Pega el código.',
    qrCaption: 'Escanéalo con la cámara del móvil',
    copyLink: 'Copiar enlace',
    linkCopied: 'Enlace copiado',
    confirm: 'Confirmar',
  },
);
